import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import ManufacturerDataGrid from '../ManufacturerDataGrid';
import ManufacturerList from '../ManufacturerList';

const Manufacturers: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <ManufacturerDataGrid />
      </If>
      <If condition={!isDesktop}>
        <ManufacturerList />
      </If>
    </>
  );
};

export default React.memo(Manufacturers);
